import { render, staticRenderFns } from "./DatabaseMigration.vue?vue&type=template&id=4b1ef616&scoped=true&"
import script from "./DatabaseMigration.vue?vue&type=script&lang=js&"
export * from "./DatabaseMigration.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseMigration.vue?vue&type=style&index=0&id=4b1ef616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ef616",
  null
  
)

export default component.exports